import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import URL from "../../constant/URL";
import List from "./list/List";
import AiPrediction from "./aiPrediction/AiPrediction";
import AnsweringQuestionsInitializer from "../answeringQuestions/questionInspection/container/AnsweringQuestionsInitializer";
import AnsweringQuestions from "../answeringQuestions/questionInspection/presentational/AnsweringQuestions";

const QuestionInspection = () => {

  const routeMatch = useRouteMatch();

  return <Route path={ `${ routeMatch.url }/:depth3` }><Children /></Route>;

};

const Children = () => {

  return (
    <Switch>
      <Route path={ URL.QUESTION_INSPECTION.LIST }><List /></Route>
      <Route path={ `${ URL.QUESTION_INSPECTION.AI_PREDICTION }/:stageCode` }><AiPrediction /></Route>
      <Route path={ `${ URL.QUESTION_INSPECTION.ANSWERING_QUESTIONS }/:testApp/:stageCode` }><AnsweringQuestionsInitializer><AnsweringQuestions /></AnsweringQuestionsInitializer></Route>
    </Switch>
  );

};

export default QuestionInspection;
